var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-extrastars',{attrs:{"intro-text":_vm.$lang.get('w4d3.game4.stars', {br: '\n'}),"questions":[
        {
            questiontext: _vm.$lang.get('w4d3.game4.body'),
            bubbleText: _vm.$lang.get('w4d3.game4.remember'),
            answers: [
                {
                    option: _vm.$lang.get('w4d3.game4.outside'),
                    correct: false
                },
                {
                    option: _vm.$lang.get('w4d3.game4.inside'),
                    correct: true
                },
                {
                    option: _vm.$lang.get('w4d3.game4.images'),
                    correct: false
                }
            ]
        },
        {
            questiontext: _vm.$lang.get('w4d3.game4.abilities'),
            bubbleText: _vm.$lang.get('w4d3.game4.video'),
            answerFontSize: 16,
            answers: [
                {
                    option: _vm.$lang.get('w4d3.game4.positive'),
                    correct: true
                },
                {
                    option: _vm.$lang.get('w4d3.game4.negative'),
                    correct: false
                },
                {
                    option: _vm.$lang.get('w4d3.game4.player'),
                    correct: false
                }
            ]
        }
    ]}})}
var staticRenderFns = []

export { render, staticRenderFns }